import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import nine from '../assets/svg/projects/nine.svg'
import ten from '../assets/svg/projects/ten.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import twelve from '../assets/svg/projects/twelve.svg'
// import thirteen from '../assets/svg/projects/thirteen.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Library Management System',
        projectDesc: 'This project aims to build an library management system that manages all the library details of schools & colleges',
        tags: ['JSP', 'SERVLET', 'MYSQL','HTML','CSS','JS','BOOTSTRAP'],
        code: 'https://github.com/cse5a/E-LIBRARY',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
    {
        id: 2,
        projectName: 'Weather Portal',
        projectDesc: 'This project is a weather portal system that allows users to know weather of a area.',
        tags: ['SPRINGBOOT', 'HTML','CSS'],
        code: 'https://github.com/sipundhal/WeatherProjectFrontEnd',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: two
    },
    {
        id: 3,
        projectName: 'Campus Recruitment System',
        projectDesc: 'Campus Recruitment System and applications manages all the placement process in colleges.',
        tags: ['PHP', 'CSS', 'HTML','CSS','JS','MYSQL'],
        code: '',
        demo: '',
        image: three
    },
    {
        id: 4,
        projectName: 'Online Exam System',
        projectDesc: 'This project involves the development of an web application for conducting online exam.',
        tags: ['PHP', 'MYSQL','HTML','CSS','JS','BOOTSTRAP'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: four
    },
    {
        id: 5,
        projectName: 'Udemy Clone UI',
        projectDesc: 'A Simple clone of Udemy Homepage',
        tags: ['React', 'CSS'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Online Course Registration',
        projectDesc: 'This project involves the development of an web application for allow student to register for subjects',
        tags: ['PHP', 'MYSQL','HTML','CSS','JS','BOOTSTRAP'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Nutrabit Admin',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work.',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Athena Admin',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work with dual admin user management.',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    },
    {
        id: 9,
        projectName: 'Techsquare LSE',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work with dual admin user management.',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: nine
    },
    {
        id: 10,
        projectName: 'InsiseJobs Admin',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work with dual admin user management .',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: ten
    },
    {
        id: 11,
        projectName: 'AsianStory Admin',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work with dual admin user management.',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eleven
    },
    {
        id: 12,
        projectName: 'ARCosmetics',
        projectDesc: 'This project involves the development of an web based Admin application where admin manage all natural product details with inquiries, notices, banners , users, and lots of permission based work with dual admin user management.',
        tags: ['Vue Js', 'MYSQL','HTML','CSS','JS','Primevue','API Integration'],
        //code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: twelve
    },
    
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/